// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function styleProps(disabled, active) {
  return {
    0: {
      className: "boxSizing-x9f619 borderColor-x9r1u3d borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1vqgdyp padding-xe8ttls backgroundColor-x7tizco borderColor-xdy0v0",
      "data-style-src": "wino-gc:src/resources/actions/OpeningButton.res.js:12"
    },
    2: {
      className: "boxSizing-x9f619 borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1vqgdyp padding-xe8ttls backgroundColor-x17suf5r borderColor-x1lkidjr backgroundColor-xfuux0i borderColor-x1uctlmt",
      "data-style-src": "wino-gc:src/resources/actions/OpeningButton.res.js:12; wino-gc:src/resources/actions/OpeningButton.res.js:28"
    },
    1: {
      className: "boxSizing-x9f619 borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1vqgdyp padding-xe8ttls backgroundColor-x7tizco borderColor-x9r1u3d borderColor-x1xfd4ba",
      "data-style-src": "wino-gc:src/resources/actions/OpeningButton.res.js:12; wino-gc:src/resources/actions/OpeningButton.res.js:36"
    },
    3: {
      className: "boxSizing-x9f619 borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1vqgdyp padding-xe8ttls backgroundColor-x17suf5r backgroundColor-xfuux0i borderColor-x9r1u3d borderColor-x1xfd4ba",
      "data-style-src": "wino-gc:src/resources/actions/OpeningButton.res.js:12; wino-gc:src/resources/actions/OpeningButton.res.js:28; wino-gc:src/resources/actions/OpeningButton.res.js:36"
    }
  }[!!active << 1 | !!disabled << 0];
}
let make = React.forwardRef((props, ref) => {
  let __disabled = props.disabled;
  let opened = props.opened;
  let disabled = __disabled !== undefined ? __disabled : false;
  let ref$1 = ref == null ? undefined : Primitive_option.some(ref);
  let match = Hover.use(ref$1, undefined, undefined);
  let match$1 = styleProps(disabled, opened);
  let match$2 = {
    className: "marginRight-x1y7amh marginTop-xvijh9v",
    "data-style-src": "wino-gc:src/resources/actions/OpeningButton.res.js:42"
  };
  let iconColor = disabled ? "#bdbdca" : opened || match[1] ? "#25243a" : "#797885";
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsxs("div", {
      children: [props.children, JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(LegacyIcon.make, {
          name: opened ? "arrow_up_light" : "arrow_down_light",
          fill: iconColor,
          size: 14
        }),
        className: match$2.className,
        style: match$2.style
      })],
      className: match$1.className,
      style: match$1.style
    }),
    ariaProps: props.ariaProps,
    disabled: disabled,
    style: {
      marginLeft: `-` + "8px"
    },
    onPress: props.onPress,
    ref: match[0]
  });
});
let make$1 = React.memo(make);
export { make$1 as make };
/* styles Not a pure module */